import {
  Divider,
  DividerVariants,
  Loader,
  LoaderSizes,
  Modal,
} from "@hid-galaxy-ui/galaxy-react";
import React from "react";
import convertToNoDecimalValue from "../../../utils/convertToNoDecimalValue";
import { useAppDispatch, useAppSelector } from "../../../redux";
import moment from "moment";
import { orderDetailSagaAction } from "../../../redux/saga/my-account/saga-actions";
import "./OrderDetailModal.scss"

const OrderDetailModal: React.FC<{
	orderID: string;
  setDetailModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ setDetailModalOpen, orderID }) => {
  const { orderDetail, status } = useAppSelector((state) => state.my_account);
  const { partnerDetails } = useAppSelector((state) => state.partner_details);
	const dispatch = useAppDispatch();
	React.useEffect(() => {
		dispatch(orderDetailSagaAction(orderID));
	},[])
  const checkNullString = (value: string | null): string => {
    if (value) {
      return value;
    }
    return "";
  };
  return (
    <Modal
      width={658}
      isDisplayCloseIcon={false}
      footerConfig={{
        secondaryBtnLabel: "CLOSE",
      }}
      onClose={() => setDetailModalOpen(false)}
      className="order-detail-modal"
    >
      {status.orderDetailLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "32px",
          }}
        >
          <Loader variant={LoaderSizes.medium} />
        </div>
      ) : (
        <>
          <h1 className="title">HID Partner Order Summary</h1>
          <h1 className="order-name">{orderDetail?.name}</h1>
          <div className="info-group">
            <p className="info-title">Created</p>
            <p className="line">
              {moment(orderDetail.processedAt).format("DD MMM, YYYY")}
            </p>
          </div>
          <div className="row">
            <div className="info-group">
              <p className="info-title">Ordered By</p>
              <p className="line">{`${checkNullString(
                orderDetail.billingAddress?.firstName
              )} ${checkNullString(orderDetail.billingAddress?.lastName)}`}</p>
              <p className="line">{`${checkNullString(
                orderDetail.billingAddress?.address1
              )}, ${checkNullString(orderDetail.billingAddress?.address2)}`}</p>
              <p className="line">{`${checkNullString(
                orderDetail.billingAddress?.city
              )}, ${checkNullString(
                orderDetail.billingAddress?.provinceCode
              )} ${checkNullString(
                orderDetail.billingAddress?.zip
              )}, ${checkNullString(orderDetail.billingAddress?.country)}`}</p>
            </div>
            <div className="info-group">
              <p className="info-title">Partner Information</p>
              <p className="line">
                {checkNullString(partnerDetails.partner_name)}
              </p>
            </div>
          </div>
          <div className="table">
            <div className="table-header">
              <div className="col-1">Item</div>
              <div className="col-2">Cost</div>
              <div className="col-3">Qty</div>
              <div className="col-4">Total</div>
            </div>
            <Divider mode={DividerVariants.Content} />
            {orderDetail.lineItems?.edges?.map((edge, index) => {
              const lineItem = edge.node;
              return (
                <div key={lineItem.title}>
                  {index === 0 ? (
                    <></>
                  ) : (
                    <Divider mode={DividerVariants.Canvas} />
                  )}
                  <div className="table-row">
                    <div className="col-1">
                      <p>{lineItem.title}</p>
                      <span>
                        {`SKU: ${lineItem.sku}`}
                      </span>
                    </div>
                    <div className="col-2">{`$${convertToNoDecimalValue(
                      (
                        Number(lineItem.originalTotalSet?.presentmentMoney?.amount) /
                        Number(lineItem.quantity)
                      ).toString()
                    )}`}</div>
                    <div className="col-3">{lineItem.quantity}</div>
                    <div className="col-4">{`$${convertToNoDecimalValue(
                      lineItem.originalTotalSet?.presentmentMoney?.amount
                    )}`}</div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="total">
          <Divider mode={DividerVariants.Content} />
            <div className="row">
              <label>Tax</label>
              <p>{`$${convertToNoDecimalValue(
                orderDetail.totalTaxSet?.presentmentMoney?.amount
              )}`}</p>
            </div>
            <Divider mode={DividerVariants.Content} />
            <div className="row">
              <label>Grand Total</label>
              <p>{`$${convertToNoDecimalValue(
                orderDetail.totalPriceSet?.presentmentMoney?.amount
              )}`}</p>
            </div>
          </div>
        </>
      )}
    </Modal>
  );
};

export default OrderDetailModal;
